import { Center, Flex, Loader, Text } from "~/ui";

interface AppLoaderProps {
  label: string;
  isLoading: boolean;
}
export const AppLoader = (props: AppLoaderProps) => {
  if (!props.isLoading) {
    return <></>;
  }
  return (
    <Center h="100vh" w="100vw" pos="fixed" top={0} left={0}>
      <Flex direction="column" align="center" gap="sm">
        <Loader color="#5198F9" size="xl" />
        <Text fw={500} size="lg">
          {props.label}
        </Text>
      </Flex>
    </Center>
  );
};
